import React from "react";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ExportExcel() {

  // ✅ Universal Date Formatter (handles all cases)
  const formatDate = (item) => {
    // Firestore Timestamp
    if (item?.createdAt?.seconds) {
      return new Date(item.createdAt.seconds * 1000).toLocaleString("en-IN");
    }

    // ISO String
    if (item?.createdAtDate) {
      const d = new Date(item.createdAtDate);
      return isNaN(d) ? "" : d.toLocaleString("en-IN");
    }

    return "";
  };

  const exportToExcel = async () => {
    try {
      const querySnapshot = await getDocs(
        collection(db, "franchisee_new_data")
      );

      const data = [];

      querySnapshot.forEach((doc) => {
        const item = doc.data();

        data.push({
          Name: item.name || "",
          Email: item.email || "",
          Mobile: item.mobile || "",
          City: item.city || "",
          Investment: item.investment || "",
          Date: formatDate(item), // ✅ FIXED
        });
      });

      if (data.length === 0) {
        alert("No data found!");
        return;
      }

      // Convert JSON → Sheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Auto column width
      const colWidths = Object.keys(data[0]).map((key) => ({
        wch: key.length + 10,
      }));
      worksheet["!cols"] = colWidths;

      // Workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Franchisee Data");

      // Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Franchisee_Data.xlsx");

    } catch (error) {
      console.error("Export Error:", error);
      alert("Export failed");
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <button className="btn btn-success" onClick={exportToExcel}>
        Download Excel
      </button>
    </div>
  );
}

export default ExportExcel;